import { colors } from '@amazd/common/static';
import { CustomTheme } from '@amazd/common/theme';
import { makeStyles } from '@mui/styles';
import { toolbarHeight } from 'styles/theme';

export default makeStyles((theme: CustomTheme) => ({
  root: {
    padding: 0,
    display: 'flex',
    background: colors.amazdGrey6,
  },
  container: {
    height: `calc(100vh - ${toolbarHeight}px)`,
    overflowY: 'auto',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  drawer: {
    '& .MuiDrawer-paper': {
      top: 'unset',
    },
    [theme.breakpoints.up('lg')]: {
      '& .MuiDrawer-paper': {
        position: 'relative',
      },
    },
  },
  sidebar: {
    background: 'white',
    width: 375,
    height: `calc(100% - ${toolbarHeight}px)`,
    display: 'flex',
    flexShrink: 0,
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRight: 'none',
  },
  sidebarTitle: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '28px',
    color: colors.black,
    margin: '8px 0px',
  },
  list: {
    padding: '0px 8px',
  },
  item: {
    color: colors.black,
    '&:hover': {
      backgroundColor: colors.grey20,
      borderRadius: 8,
    },
  },
  itemSelected: {
    backgroundColor: colors.grey20,
    borderRadius: 8,
  },
  itemIcon: {
    color: 'currentColor',
    minWidth: 24,
    marginRight: 8,
  },
  link: {
    textDecorationLine: 'none',
    '&:hover': {
      textDecorationLine: 'none',
    },
  },
}));
